import { Button } from '@/_component/Common';
import { DashboardAction, DashboardCardConfig } from '@/_component/home/dashboard-profile-card/types';
import { useLanguageContext } from '@/hooks';

export interface KnowMoreProps {
    config: DashboardCardConfig;
    executeAction: (action: DashboardAction) => void;
};

const KnowMore = ({ config, executeAction }: KnowMoreProps) => {
    const { language } = useLanguageContext();

    return (
        <div className="bg-white card kg-dark-gray py-3 shadow-sm rounded-4 text-left p-3 d-flex justify-content-between" style={{ background: 'linear-gradient(90deg, #FDF9CF -0.59%, #FCE2E8 100%)' }}>
            <h5 className="ms-2 mb-3 fw-bold text-dark">{language(config.knowMore.titleKey, config.knowMore.title)}</h5>
            <div className="d-flex align-items-end justify-content-between position-relative mt-2">
                <Button white outline rounded small onClick={() => executeAction(config.knowMore.action)}>
                    <span className="me-2">{language(config.knowMore?.buttonLabelKey) || "Click here to know more"}</span>
                    <i className="bi bi-arrow-right fw-bold icon-fs-1"></i>
                </Button>
                <img className="bottom-0 img-fluid position-absolute end-0 pt-1" src={config.knowMore.imageSrc} style={{ maxHeight: 90 }} />
            </div>
        </div>
    )
};

export default KnowMore;